import { ReactElement } from 'react'
import Layout from '../../../components/layout'
import ShopProductEdit from '../../../components/Shops/Products/AddProduct'


const ShopProductEditPage = (): ReactElement => {
  return (
    <Layout >
      <ShopProductEdit />
    </Layout>
  )
}

export default ShopProductEditPage
